import {
  IconApps,
  IconBolt,
  IconChartBar,
  IconClock,
  IconFiles,
  IconLibrary,
  IconPalette,
  IconPhotoVideo,
  IconRocket,
  IconSettings,
  IconTools,
  IconUserPlus,
  IconVariable,
} from "@tabler/icons-react";

interface IMenuItem {
  icon: React.ElementType<{ className?: string }>;
  label: string;
  action: string;
  expandable?: boolean;
  type?: string[];
  badge?: string;
}

export const PLATFORM_MENU: IMenuItem[] = [
  {
    icon: IconClock,
    label: "Dashboard",
    action: "dashboard",
  },
  {
    icon: IconFiles,
    label: "Stories",
    action: "stories",
    expandable: true,
  },
  {
    icon: IconChartBar,
    label: "Analytics",
    action: "analytics",
  },
  {
    icon: IconApps,
    label: "Integrations",
    action: "integrations",
    type: ["orgAdmin", "administrator", "storydoc admin"],
    badge: "New",
  },
  {
    icon: IconBolt,
    label: "Automations",
    action: "automations",
  },
  {
    icon: IconRocket,
    label: "Power ups",
    action: "power-ups",
    type: ["orgAdmin", "administrator", "storydoc admin"],
  },
];

export const LIBRARIES_MENU = [
  {
    icon: IconPalette,
    label: "Design",
    action: "design",
    hiddenFor: ["user", "creator lite", "creatorLite"],
    path: "/pages/design",
  },
  {
    icon: IconPhotoVideo,
    label: "Media",
    action: "media",
  },
  {
    icon: IconLibrary,
    label: "Slides",
    action: "slides",
  },
  {
    icon: IconTools,
    label: "Templates",
    action: "templates",
    path: "/pages/editor/templates",
    hiddenFor: ["user", "creator lite", "creatorLite"],
  },
  {
    icon: IconVariable,
    label: "Variables",
    action: "variables",
    hiddenFor: ["user", "creator lite", "creatorLite"],
    path: "/pages/variables",
  },
];

export const FOOTER_MENU = [
  {
    icon: IconUserPlus,
    label: "Invite members",
    action: "invite",
  },
  {
    icon: IconSettings,
    label: "Organization settings",
    action: "settings",
  },
];
